/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import adminServices from '../../../../services/adminServices';
import Iconify from '../../../../components/Iconify';
import DeleteAlert from '../../../../components/modal/DeleteModal';
import SnackBar from '../../../../components/snackbar/snackbar';
import ResponsiveTable from '../../../../components/Table/Responsivetable';

function AddLearnerDrawer({ open, onClose, onSubmit, loading }) {
  const initialForm = { firstName: '', lastName: '', email: '', phone: '' };
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!form.firstName.trim()) errs.firstName = 'First Name is required';
    if (!form.lastName.trim()) errs.lastName = 'Last Name is required';
    if (!form.email.trim()) errs.email = 'Email Address is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errs.email = 'Enter a valid email';
    return errs;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handleSubmit = () => {
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    onSubmit(form);
  };

  const handleClose = () => {
    setForm(initialForm);
    setErrors({});
    onClose();
  };

  useEffect(() => {
    if (!open) { setForm(initialForm); setErrors({}); }
  }, [open]);

  if (!open) return null;

  return (
    <>
      <div
        className="fixed inset-0 top-[56px] bg-black bg-opacity-30 z-40"
        role="button"
        tabIndex={0}
        onClick={handleClose}
        onKeyDown={(e) => e.key === 'Escape' && handleClose()}
        aria-label="Close drawer"
      />
      {/* Drawer panel */}
      <div className="fixed right-0 top-[68px] h-[calc(100%-56px)] w-[380px] bg-white shadow-2xl z-50 flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-[15px] font-semibold text-gray-900">Add Learner</h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 text-2xl leading-none w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100"
          >
            ×
          </button>
        </div>

        <form autoComplete="off" onSubmit={(e) => e.preventDefault()} className="flex-1 overflow-y-auto px-6 py-5 flex flex-col gap-5">

          {/* First Name */}
          <div>
            <label htmlFor="learner-firstname" className="block text-[13px] font-medium text-gray-700 mb-1">
              First Name <span className="text-red-500">*</span>
              <input
                id="learner-firstname"
                type="text"
                autoComplete="off"
                placeholder="e.g. Priya"
                value={form.firstName}
                onChange={(e) => handleChange('firstName', e.target.value)}
                className={`w-full border rounded-md px-3 py-2 text-[13px] text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.firstName ? 'border-red-400 bg-red-50' : 'border-gray-300'}`}
              />
            </label>
            {errors.firstName && <p className="text-[11px] text-red-500 mt-1">{errors.firstName}</p>}
          </div>

          {/* Last Name */}
          <div>
            <label htmlFor="learner-lastname" className="block text-[13px] font-medium text-gray-700 mb-1">
              Last Name <span className="text-red-500">*</span>
              <input
                id="learner-lastname"
                type="text"
                autoComplete="off"
                placeholder="e.g. Mehta"
                value={form.lastName}
                onChange={(e) => handleChange('lastName', e.target.value)}
                className={`w-full border rounded-md px-3 py-2 text-[13px] text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.lastName ? 'border-red-400 bg-red-50' : 'border-gray-300'}`}
              />
            </label>
            {errors.lastName && <p className="text-[11px] text-red-500 mt-1">{errors.lastName}</p>}
          </div>

          {/* Email */}
          <div>
            <label htmlFor="learner-email" className="block text-[13px] font-medium text-gray-700 mb-1">
              Email Address <span className="text-red-500">*</span>
              <input
                id="learner-email"
                type="email"
                autoComplete="off"
                placeholder="learner@organisation.com"
                value={form.email}
                onChange={(e) => handleChange('email', e.target.value)}
                className={`w-full border rounded-md px-3 py-2 text-[13px] text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.email ? 'border-red-400 bg-red-50' : 'border-gray-300'}`}
              />
            </label>
            {errors.email && <p className="text-[11px] text-red-500 mt-1">{errors.email}</p>}
          </div>

          {/* Phone */}
          <div>
            <label htmlFor="learner-phone" className="block text-[13px] font-medium text-gray-700 mb-1">
              Phone
              <PhoneInput
                country={'us'}
                specialLabel={''}
                value={form.phone}
                onChange={(e) => handleChange('phone', e)}
                // onBlur={handleBlur}
                inputProps={{ name: 'phone' }}
              />
              {/* <input
                id="learner-phone"
                type="text"
                autoComplete="off"
                placeholder="+91 XXXXX XXXXX"
                value={form.phone}
                onChange={(e) => handleChange('phone', e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-[13px] text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
              /> */}
            </label>
          </div>

        </form>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            type="button"
            onClick={handleClose}
            disabled={loading}
            className="px-4 py-2 text-[13px] font-medium text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 text-[13px] font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-60 flex items-center gap-2"
          >
            {loading && (
              <svg className="animate-spin w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
              </svg>
            )}
            Add Learner
          </button>
        </div>
      </div>
    </>
  );
}

export default function User(props) {
  const location = useLocation();
  const { from: locationFrom } = location.state || {};
  const from = props.clientDetails?.id || locationFrom;

  const [loading, setLoading] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [userId, setUserId] = useState();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [userList, setUserList] = useState(props?.data || []);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [addLearnerLoading, setAddLearnerLoading] = useState(false);

  const [searchText, setSearchText] = useState('');
  const [statusFilter, setStatusFilter] = useState('All Status');
  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const statusRef = useRef();

  useEffect(() => {
    setUserList(props?.data || []);
  }, [props.data]);

  useEffect(() => {
    const handler = (e) => {
      if (statusRef.current && !statusRef.current.contains(e.target)) {
        setStatusDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    props.onPageChange(0);
  };

  const handleStatusChange = (opt) => {
    setStatusFilter(opt);
    setStatusDropdownOpen(false);
    props.onPageChange(0);
  };

  const handleAddLearner = async (form) => {
    setAddLearnerLoading(true);
    try {
      const payload = {
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        email: form.email.trim(),
        password: form.password,
        roleCode: 'AUTH_USER',
        clientId: from,
      };

      if (props?.clientDetails?.slug) {
        payload.schema = `tenant_${props.clientDetails.slug}`;
      }

      const result = await adminServices.createTenantUser(payload);
      if (result.ok) {
        props.getUserLists();
        setDrawerOpen(false);
        setOpenSnackbar(true);
        setSnackbarTitle(result.data.message || 'Learner added successfully');
      } else {
        setOpenSnackbar(true);
        setSnackbarTitle(result.data?.message || 'Failed to add learner');
      }
    } catch (error) {
      console.log(error);
      setOpenSnackbar(true);
      setSnackbarTitle('Something went wrong');
    } finally {
      setAddLearnerLoading(false);
    }
  };

  const handleModal = (id) => { setDeleteAlert(true); setUserId(id); };

  const handleExportCSV = async () => {
    try {
      const schema = props.clientDetails?.slug ? `tenant_${props.clientDetails.slug}` : null;
      const response = await adminServices.getlearners(from, 0, props.total, schema, 'AUTH_USER');

      const allData = response.ok ? (response.data.users || []) : filteredData;

      const headers = ['Full Name', 'Email', 'Status', 'Date Added'];
      const rows = allData.map((row) => [
        `${row.firstName || ''} ${row.lastName || ''}`.trim(),
        row.email || '',
        row.status || '',
        row.createdAt
          ? new Date(row.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
          : '',
      ]);
      const csvContent = [headers, ...rows]
        .map((r) => r.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
        .join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'learners.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async () => {
    try {
      const result = await adminServices.deleteUserDetails(from, userId);
      if (result.ok) {
        props.getUserLists();
        setDeleteAlert(false);
        setOpenSnackbar(true);
        setSnackbarTitle(result.data.message);
      } else {
        setOpenSnackbar(true);
        setSnackbarTitle(result.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSwitch = async (row) => {
    const newStatus = row.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
    setUserList(userList.map((item) =>
      item.id === row.id ? { ...item, status: newStatus } : item
    ));
    try {
      const res = await adminServices.handleUserStatus(from, row.id, { status: newStatus });
      if (res.ok) {
        props.getUserLists();
        setOpenSnackbar(true);
        setSnackbarTitle(res.data.message);
      } else {
        setOpenSnackbar(true);
        setSnackbarTitle(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const filteredData = (userList || []).filter((row) => {
    const matchesSearch =
      !searchText ||
      row.name?.toLowerCase().includes(searchText.toLowerCase()) ||
      row.email?.toLowerCase().includes(searchText.toLowerCase());
    const matchesStatus =
      statusFilter === 'All Status' || row.status === statusFilter.toUpperCase();
    return matchesSearch && matchesStatus;
  });

  const columns = [
    {
      key: 'name',
      label: 'FULL NAME',
      render: (row) => (
        <div className="flex items-center gap-1">
          <span className="text-sm font-semibold text-gray-900">{row.firstName} {row.lastName}</span>
          {row.role === 'CLIENT_ADMIN' && (
            <Iconify icon="mdi:crown" width={14} height={14} color="orange" />
          )}
        </div>
      ),
    },
    {
      key: 'email',
      label: 'EMAIL',
      render: (row) => <span className="text-sm text-gray-600">{row.email}</span>,
    },
    {
      key: 'status',
      label: 'STATUS',
      render: (row) => (
        <span className={`text-sm font-medium ${row.status === 'ACTIVE' ? 'text-green-600' : 'text-gray-400'}`}>
          {row.status === 'ACTIVE' ? 'Active' : 'Inactive'}
        </span>
      ),
    },
    {
      key: 'dateAdded',
      label: 'DATE ADDED',
      render: (row) => (
        <span className="text-sm text-gray-600">
          {row.createdAt
            ? new Date(row.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
            : '—'}
        </span>
      ),
    },
  ];

  const totalCount = props.total || 0;

  return (
    <div className="mt-4">

      {/* Header bar */}
      <div className="flex items-center justify-between mb-4">
        <span className="text-[14px] font-semibold text-gray-700">
          Learners ({totalCount})
        </span>
        <div className="flex items-center gap-2">
          <button
            type="button"
            className="flex items-center gap-1.5 px-3 py-[7px] text-[13px] font-medium border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 transition"
          >
            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            Bulk Upload
          </button>

          <button
            type="button"
            onClick={() => setDrawerOpen(true)}
            className="flex items-center gap-1.5 px-4 py-[7px] text-[13px] font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Add Learner
          </button>
        </div>
      </div>

      {/* Filters row */}
      <div className="flex items-center gap-3 mb-4">
        <input
          type="text"
          value={searchText}
          onChange={handleSearchChange}
          placeholder="Search by name or email"
          autoComplete="off"
          className="border border-gray-300 rounded-md px-3 py-[7px] text-[13px] text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-500 w-52 bg-white"
        />

        <div className="relative" ref={statusRef}>
          <button
            type="button"
            onClick={() => setStatusDropdownOpen((o) => !o)}
            className="flex items-center gap-2 border border-gray-300 rounded-md px-3 py-[7px] text-[13px] text-gray-700 bg-white hover:bg-gray-50"
          >
            {statusFilter}
            <svg className={`w-3.5 h-3.5 text-gray-500 transition-transform ${statusDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {statusDropdownOpen && (
            <div className="absolute z-50 mt-1 w-36 bg-white border border-gray-200 rounded-md shadow-lg overflow-hidden">
              {['All Status', 'Active', 'Inactive'].map((opt) => (
                <button
                  key={opt}
                  type="button"
                  onClick={() => handleStatusChange(opt)}
                  className={`w-full text-left px-4 py-2.5 text-[13px] ${statusFilter === opt ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-50'}`}
                >
                  {opt}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Table */}
      <ResponsiveTable columns={columns} data={filteredData} loading={props.loading} />

      {/* Footer */}
      {totalCount > 0 && (() => {
        const currentPage = props.page || 0;
        const pageSize = props.pageSize || 10;
        const totalPages = Math.ceil(totalCount / pageSize);
        const rangeStart = currentPage * pageSize + 1;
        const rangeEnd = Math.min(rangeStart + pageSize - 1, totalCount);
        return (
          <div className="flex items-center justify-between mt-4 px-1">
            <span className="text-[12px] text-gray-500">
              Showing {rangeStart}–{rangeEnd} of {totalCount} learners
            </span>
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => props.onPageChange(currentPage - 1)}
                disabled={currentPage === 0 || props.loading}
                className={`text-[13px] ${currentPage === 0 ? 'text-gray-400 cursor-not-allowed' : 'text-blue-600 hover:underline'}`}
              >
                Prev
              </button>
              <span className="text-[12px] text-gray-500">{currentPage + 1} / {totalPages}</span>
              <button
                type="button"
                onClick={() => props.onPageChange(currentPage + 1)}
                disabled={currentPage >= totalPages - 1 || props.loading}
                className={`text-[13px] ${currentPage >= totalPages - 1 ? 'text-gray-400 cursor-not-allowed' : 'text-blue-600 hover:underline'}`}
              >
                Next
              </button>
              <button
                type="button"
                onClick={handleExportCSV}
                className="flex items-center gap-1.5 text-[13px] text-gray-600 border border-gray-300 rounded-md px-3 py-1.5 hover:bg-gray-50 transition"
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Export CSV
              </button>
            </div>
          </div>
        );
      })()}

      {/* Add Learner Drawer */}
      <AddLearnerDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onSubmit={handleAddLearner}
        loading={addLearnerLoading}
      />

      <DeleteAlert
        open={deleteAlert}
        title="Are you sure you want delete this User"
        confirm={handleDelete}
        close={() => setDeleteAlert(false)}
      />
      <SnackBar open={openSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />
    </div>
  );
}